import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  customProperties: true,
  iconfont: 'mdi',
  theme: {
    primary: '#009688',
    secondary: '#B2DFDB',
    accent: '#B2DFDB',
    error: '#c62828',
    danger: '#ffcdd2',

    primaryDark: '#004D40',
    primaryLight: '#B2DFDB',
    dangerDark: '#c62828',
  }
})